<template>
    <section id="ct-home" style="width:100%;height:100%;" class="flex-col">

        <hgroup style="width:100%;min-height:8.60rem;overflow: hidden">
            <img src="@/assets/contact/logo4.png" style="width:100%;position: absolute;top:0;left:-1rem;">
            <img src="@/assets/contact/logo3.png" style="width:7.48rem;position: absolute;top:2.76rem;left:-2rem;">


            <!--      <img src="@/assets/contact/logo1.png" style="position: absolute;left:3rem;top:0.79rem;width:1.54rem;height:1.54rem">-->

            <section class="flex-col">


                <section style="margin-top:0.08rem;align-self: flex-end;margin-right: 1rem;max-width: 6.5rem"
                         class="flex-col">

                  <h1 class="font-36" color-title style="margin-top: 0.3rem"><b>Tentang AdaPundi</b>
                  </h1>
                  <h4 color-small-title style="margin-top:0.20rem;">PT. Info Tekno Siaga (AdaPundi) adalah
                    perusahaan pemberi pinjaman peer to peer (P2P) berbasis teknologi yang terdaftar di Otoritas Jasa
                    Keuangan (OJK) dengan nomor registrasi S-448/NB.213/2019 dan juga diinvestasikan oleh banyak
                    perusahaan modal ventura yang terkenal seperti Sequoia Capital. AdaPundi bertujuan menjadi
                    perusahaan platform lending online nomor satu di Indonesia dan berkomitmen untuk selalu ada bagi
                    mereka yang membutuhkan bantuan dana sementara dengan memberikan akses kemudahan, cepat dan
                    menetapkan standar tertinggi dalam perlindungan dan kerahasian data nasabah.
                    AdaPundi menyediakan pilihan pinjaman dari Rp400.000 hingga 4000.000 dengan tempo pelunasan 21 hari
                    hingga 180 hari. Kami memberikan kemudahan dan kenyamanan dengan proses yang sepenuhnya digital,
                    hanya dengan KTP yang dibutuhkan tanpa adanya jaminan. Dana diberikan dengan cepat dalam waktu 5
                    menit setelah pengajuan disetujui.
                  </h4>

                  <h4 color-title style="margin-top:0.15rem;">Our Location</h4>
                  <h4 style="margin-top:0.11rem;" color-small-title>Capital Place Building, lantai
                    47, Suite B, Jalan Jenderal Gatot Subroto, Kav. 18, Kel. Kuningan Barat, Kec. Mampang Prapatan,
                    Provinsi Daerah Khusus Ibu Kota Jakarta 12710</h4>
                    <h3 color-title style="margin-top:0.26rem;">Visi</h3>
                    <h4 color-small-title style="margin-top:0.11rem">Menjadi penyedia solusi keuangan taktis terdepan
                        bagi konsumen Indonesia.</h4>
                    <h3 color-title style="margin-top:0.26rem;">Misi</h3>
                    <h4 color-small-title style="margin-top:0.11rem">1. Menjunjung tinggi hukum Republik Indonesia & regulasi Otoritas Jasa
                        Keuangan; dan mewujudkannya dalam produk teknologi finansial yang aman, kredibel, transparan,
                        dan mudah digunakan.</h4>
                    <h4 color-small-title style="margin-top:0.11rem">2. Menyediakan solusi & pengalaman positif bagi produktivitas ekonomi
                        konsumen, melalui metode analisa kelayakan kredit yang bersandar pada terapan terbaik teknologi
                        informasi terkini.</h4>
                    <h4 color-small-title style="margin-top:0.11rem">3. Secara berkala, melalui berbagai metode & sarana komunikasi; menyediakan
                        pengetahuan finansial yang berdampak positif bagi pertumbuhan kecerdasan finansial
                        konsumen.</h4>


                    <hgroup style="margin-top:0.28rem" class="flex-row">
                        <section class="flex-col">
                            <h4 color-title>Email</h4>
                            <h4 color-small-title style="margin-top:0.11rem">cs@adapundi.com</h4>
                        </section>
                        <section class="flex-col" style="margin-left:0.44rem;">
                            <h4 color-title>Call Center</h4>
                            <h4 color-small-title style="margin-top:0.11rem">+6221 50860666</h4>
                        </section>
                    </hgroup>

                    <hgroup class="flex-col" style="margin-top:0.28rem">
                        <h4 color-title>Follow us</h4>
                        <hgroup class="flex-row" style="margin-top: 0.17rem">
                            <img @click="btnFllow(item)" v-for="item in fllow" :src="item.src" :key="item.src"
                                 style="cursor:pointer;height:0.16rem;min-height:0.16rem;margin-right:0.15rem;" />
                        </hgroup>

                    </hgroup>
                </section>

            </section>

<!--            <section style="margin-left:2.31rem;margin-top:8.32rem;">-->

<!--                <h1 class="font-36" color-title><b>Contact Us</b></h1>-->
<!--                <h4 color-small-title style="margin-top:0.11rem;max-width:6.74rem;">Kirim pertanyaan Anda kepada-->
<!--                    Kami.</h4>-->

<!--                <h6 color-small-title style="margin-top:0.45rem">Nama Lengkap</h6>-->
<!--                <input class="input" style="margin-top:0.06rem;width:4.21rem;height:0.4rem;" />-->

<!--                <h6 color-small-title style="margin-top:0.25rem">Email</h6>-->
<!--                <input class="input" style="margin-top:0.06rem;width:4.21rem;height:0.4rem;" />-->

<!--                <h6 color-small-title style="margin-top:0.25rem">Pesan</h6>-->
<!--                <input class="input" style="margin-top:0.06rem;width:4.21rem;height:1.18rem;" />-->

<!--                <button style="margin-top:0.31rem;display: block;">submit</button>-->

<!--                <hgroup style="margin-top:2.05rem">-->
<!--                    <h1 class="font-36" color-title>We are Hiring!</h1>-->
<!--                    <h4 style="margin-top:0.24rem;max-width: 7.2rem" color-small-title>AdaPundi is growing and we are-->
<!--                        looking for talented, high energy people to help us improve our performance. </h4>-->

<!--                    <section class="flex-col" style="margin-top:0.34rem">-->

<!--                        <hgroup class="flex-row" v-for="group in tips" style="margin-bottom:0.29rem;">-->
<!--                            <section class="flex-row flex-cross-center" style="width:4rem;" v-for="item in group">-->
<!--                                <div style="width:0.04rem;height:0.04rem;border-radius: 50%;background: #FF7227;margin-right:0.18rem">-->
<!--                                </div>-->
<!--                                <span style="color:#FF7227;">{{item.title}}</span>-->
<!--                                <img src="@/assets/arrow-right.png"-->
<!--                                     style="margin-left:0.14rem;width:0.11rem;height:0.11rem">-->
<!--                            </section>-->
<!--                        </hgroup>-->
<!--                    </section>-->


<!--                    <h4 color-small-title>Sent your recent curriculum vitae to:</h4>-->
<!--                    <h4 color-title style="margin-bottom:1.26rem">recruitment@adapundi.com</h4>-->


<!--                </hgroup>-->
<!--            </section>-->

            <img src="@/assets/contact/logo2.png"
                 style="width:4.6rem;position: absolute;right:0;top:9.91rem;z-index:-2;">

        </hgroup>

        <com-download></com-download>

    </section>
</template>
<script>


  import comDownload from '@/components/download';
  // import mixin from '@/plugin/mixin';

  export default {
    mixins: [],
    name: 'contact',
    computed: {},
    async mounted() {

    },
    activated() {
      // this.resetTabIndex(this.$route.name);

    },
    data() {
      return {
        bottomTabIndex: 0,
        tips: [
          [{title: 'License & Permit Administrator'}, {title: 'Social Media Admin'}],
          [{title: 'Marketing Manager'}, {title: 'UI/UX Designer'}],
        ],
        fllow: [
          {
            src: require('@/assets/footer-icon-yt.png'),
            link: 'https://www.youtube.com/channel/UCz6krbINnDqj1wDIe-_r3CA',
          },
          {src: require('@/assets/footer-icon-it.png'), link: 'https://www.instagram.com/adapundiofficial'},
          {src: require('@/assets/footer-icon-fb.png'), link: 'https://www.facebook.com/AdaPundiOfficial/'},
          {src: require('@/assets/footer-icon-in.png'), link: 'https://www.instagram.com/adapundiofficial/'},
          {src: require('@/assets/footer-icon-tw.png'), link: 'https://twitter.com/AdaPundi/'},
        ],
      };
    },
    methods: {
      btnFllow() {

      },
    },
    components: {
      comDownload,
    },
  };

</script>
<style lang="scss">

</style>
<style scoped lang="scss">
    .input {
        border: 1px solid rgba(6, 167, 137, 0.10980392156862745);;
        border-radius: 0.16rem;
        background: white;
    }

    button {
        width: 4.21rem;
        height: 0.6rem;
        background: rgba(255, 114, 39, 1);
        opacity: 1;
        border-radius: 0.32rem;
    }

</style>
